module.exports = __webpack_public_path__ + "static/img/success.fb5b8e37.png";